import { jsx, jsxs } from "react/jsx-runtime";
import React from "react";
import PropTypes from "prop-types";
import LoginComponent from "./login/loginComponent";
function renderCss(cssFile) {
  if (cssFile && /^https:.*\.css$/.test(cssFile)) {
    return /* @__PURE__ */ jsx("link", { rel: "stylesheet", type: "text/css", href: cssFile });
  }
}
export default function LoginPage({ isInIframe, cssFile }) {
  const classNames = [
    "nexio",
    "retailIframe",
    isInIframe ? "inIframe" : "",
    "loaded"
  ].join(" ").trim();
  return /* @__PURE__ */ jsxs("div", { className: classNames, children: [
    renderCss(cssFile),
    /* @__PURE__ */ jsx(LoginComponent, {})
  ] });
}
LoginPage.propTypes = {
  isInIframe: PropTypes.bool,
  cssFile: PropTypes.string
};
LoginPage.defaultProps = {
  isInIframe: false
};
